import React, { FC, ReactElement, useEffect, useState } from "react";
import { Box, useDarkMode } from "ui-components";
import useSession from "ui-io/use-session";

import styled from "styled-components";
import { Classes, TabId } from "@blueprintjs/core";

import GlobalErrorBoundary from "ui-components/global-error-boundary";
import { DashboardHeader, Sidebar } from "./shared";
import PageComponent from "ui-components/page-component";
import { useLocation, useNavigate } from "react-router-dom";

const Layout: FC<{ children: ReactElement }> = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [darkMode] = useDarkMode();
  const { isAuthenticated } = useSession();
  const [tabValue, setTabValue] = useState<TabId>("dashboard");

  useEffect(() => {
    if (tabValue !== pathname)
      setTabValue(pathname.split("/")?.pop() as string);
  }, [pathname]);

  const handleTabChange = (tab: string | null) => {
    if (tab !== null) {
      setTabValue(tab);
      navigate(`/${tab}`);
    }
  };
  return (
      <StyledLayout className={darkMode ? Classes.DARK : ""}>
        <Box flexDir="row">
          {isAuthenticated && (
            <Sidebar tabValue={tabValue} handleTabChange={handleTabChange} />
          )}

          <RightContainer>
            {isAuthenticated && <DashboardHeader />}
            <PageComponent fill padTop={0}>
              <StyledContents>
                <GlobalErrorBoundary>
                  {children ? children : null}
                </GlobalErrorBoundary>
              </StyledContents>
            </PageComponent>
          </RightContainer>
        </Box>
      </StyledLayout>
  );
};

export default Layout;

const RightContainer = styled.div`
  overflow: hidden;
  height: 100vh;
  width: calc(100% - 264px);
  margin: auto;
`;
const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const StyledContents = styled.main`
  padding: 40px;
  flex: 1 1;
  width: 100%;
  overflow: unset;
  margin-bottom: 70px;
`;
